<!-- Created by Alex Poh. on 13/04/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<div class="container">
  <svg class="sunburst" #sunburstContainer></svg>
</div>
